import * as React from 'react';
const SvgShieldFaield = (props) => (
  <svg
    width={16}
    height={16}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      opacity={0.12}
      d="M7.99121 1.97949C7.99734 1.97864 8.00365 1.97861 8.00977 1.97949C7.99964 1.97801 7.99957 1.97655 8.02344 1.98438C8.05227 1.99384 8.09051 2.00855 8.16406 2.03613L11.7383 3.37598C12.2832 3.58033 12.4042 3.63554 12.4854 3.70703C12.5747 3.78576 12.6432 3.88578 12.6855 3.99707C12.724 4.09812 12.7334 4.2301 12.7334 4.81152V8C12.7334 9.41255 11.9608 10.6836 10.9541 11.7324C9.95398 12.7743 8.78956 13.5261 8.16309 13.8916C8.12522 13.9137 8.09763 13.9306 8.07324 13.9443C8.0492 13.9579 8.03352 13.9658 8.02344 13.9707C8.02062 13.9721 8.0183 13.9729 8.0166 13.9736C8.01241 13.9739 8.0065 13.9746 8 13.9746C7.9933 13.9746 7.98759 13.974 7.9834 13.9736C7.98171 13.9729 7.97925 13.972 7.97656 13.9707C7.96648 13.9658 7.95163 13.9578 7.92773 13.9443C7.90328 13.9306 7.87491 13.9138 7.83691 13.8916C7.21033 13.526 6.04677 12.7741 5.04688 11.7324C4.04014 10.6836 3.2666 9.41263 3.2666 8V4.81152C3.26661 4.23062 3.27612 4.09812 3.31445 3.99707C3.3568 3.88577 3.42627 3.78578 3.51562 3.70703C3.5968 3.63561 3.71738 3.5801 4.26172 3.37598L7.83691 2.03613C7.91053 2.00853 7.94872 1.99382 7.97754 1.98438C8.00115 1.97664 8.00102 1.97803 7.99121 1.97949Z"
      fill="#6D659D"
      stroke="#6D659D"
      strokeWidth={1.2}
    />
    <path
      d="M7.99414 5.04892V8.70108"
      stroke="#6D659D"
      strokeWidth={1.2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.99414 10.9511H7.99977"
      stroke="#6D659D"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.53499 14.4098C7.68259 14.4959 7.75639 14.539 7.86053 14.5613C7.94139 14.5787 8.05926 14.5787 8.14013 14.5613C8.24426 14.539 8.31806 14.4959 8.46566 14.4098C9.76433 13.6522 13.3337 11.2722 13.3337 7.99993V4.81164C13.3337 4.27863 13.3337 4.01213 13.2465 3.78304C13.1695 3.58067 13.0443 3.40009 12.8819 3.25693C12.698 3.09487 12.4485 3.00129 11.9494 2.81414L8.37486 1.47369C8.23626 1.42171 8.16699 1.39573 8.09566 1.38543C8.03246 1.37629 7.96819 1.37629 7.90499 1.38543C7.83366 1.39573 7.76439 1.42171 7.62579 1.47369L4.05126 2.81414C3.55219 3.00129 3.30266 3.09487 3.11877 3.25693C2.95631 3.40009 2.83117 3.58067 2.75417 3.78304C2.66699 4.01213 2.66699 4.27863 2.66699 4.81164V7.99993C2.66699 11.2722 6.2363 13.6522 7.53499 14.4098Z"
      stroke="#6D659D"
      strokeWidth={1.2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SvgShieldFaield;
